import React from 'react'
import Modal from 'react-modal';
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { modal } from '../../core/utilities/modal'

import NavLink from '../Routes/NavLink'

import { quickBooksHandler } from '../../helpers/Integrations/QuickBooks/QuickBooksHandler'
import { modalStyles } from '../../core/controllers/ModalStyles';

export default class QuickBooksDataExplorer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            logs: null,
            showModal: false,
            selectedRow: null
        };

    }

    componentDidMount() {
        var self = this;
        quickBooksHandler.getData(function(response) {
            self.setState({
                logs: response.data
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatTypes(cell, row) {
        if(cell == 'GetCustomers') {
            return 'Get Customers';
        } else if (cell == 'GetPayments') {
            return 'Get Customer Payments';
        } else if (cell == 'SendRentPayment') {
            return 'Send Rent Payments';
        }
    }

    formatData(cell, row) {
        if(row.type == 'GetCustomers') {
            if(cell != null && cell.length > 0) {
                return cell.length + ' customers retrieved.';
            }
        } else if(row.type == 'GetPayments') {
            if(cell != null && cell.length > 0) {
                return cell.length + ' payments retrieved.';
            } else {
                return 'no data retrieved.'
            }
        } else if(row.type == 'SendRentPayment') {
            return 'no data to display.'
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    runAction() {
        var self = this;
        quickBooksHandler.runAction(this.state.actionType, function(response) {
            modal.showInfo("Request has been queued.  Once your QuickBooks asks us for information, we'll pass along the request!", "success", "top", "center");
        });
    }

    actionChange(e) {
        this.setState({
            logs: null
        });
    }

    exportData(e) {
        quickBooksHandler.exportCsv(this.state.reportType, function(response) {
            modal.showInfo("Your download will begin shortly.", "success", "top", "center");
        });
    }

    formatMoney(money) {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        return formatter.format(money);
    }

    formatDate(cell, row) {
        if(cell) {
            return moment(cell).local().format('D MMM YYYY, h:mm a');
        } else {
            return 'Not Set';
        }
    }

    didSelectRow(row) {
        if (row.type != 'SendRentPayment') {
            this.setState({
                selectedRow: row,
                showModal: true
            })
        }
    }

    handleCloseModal() {
        this.setState({
            showModal: false,
            selectedRow: null
        });
    }

    addTenants() {
        var self = this;
        modal.showDangerModalWithOK("Adding Tenants", "You are about to add customers as tenants into Leasey.  We will only add the customers who have an email to use.  Customers will also receive an email to accept the invite.", "Yes, Continue");
        jQuery(".move-on").on('click',function() {
            quickBooksHandler.addTenantsFromQBImport(self.state.selectedRow, function(response) {
                modal.showInfo("Tenants with a valid email were added and will be emailed shortly by Leasey.", "success", "top", "center");
                self.setState({
                    showModal: false,
                    selectedRow: null
                });
            })
        });
    }

    addPayments() {
        var self = this;
        modal.showDangerModalWithOK("Adding Payments", "You are about to add the payments to any lease that matches the Customer Name using the QuickBooks Customer Ref #.", "Yes, Import");
        jQuery(".move-on").on('click',function() {
            quickBooksHandler.addPaymentsFromQB(self.state.selectedRow, function(response) {
                modal.showInfo("Any matching payments that referenced the lease quickbooks ref # have been successfully added.", "success", "top", "center");
                self.setState({
                    showModal: false,
                    selectedRow: null
                });
            })
        });
    }

    render(){
        const self        = this;
        const logs        = this.state.logs;
        const selectedRow = this.state.selectedRow;
        const options = {
            onRowClick: this.didSelectRow.bind(this)
        };

        const exploreDataModal = (
            <Modal
                isOpen={this.state.showModal}
                onRequestClose={this.handleCloseModal.bind(this, false)}
                style={modalStyles.getModalStyles()}
                ariaHideApp={false}
            >
            <div class="row">
                <div class="qb-exit-x modal-exit-icon pull-right"
                    onClick={this.handleCloseModal.bind(this, false)}
                />
            </div>
            <form>
                <div class="row">
                    { selectedRow !== null && (
                        selectedRow.data == null ? (
                            <p class="center-text">
                                No data available.
                            </p>
                        ) : (
                            selectedRow.type == 'GetCustomers' ? (
                                <div>
                                    <div class="row">
                                        <div class="modal-section-title col-md-12" style={{marginBottom: "5px", marginTop: "15px"}}>Retrieved Customers</div>
                                        <div class="modal-section-content col-md-12" style={{fontSize: "13px"}}>You can add these customers as Tenants using the "Convert to Tenants" button.</div>
                                    </div>
                                    <div class="col-md-12 col-sm-12">
                                        { selectedRow.data != null && selectedRow.data.map(function(customer, index){
                                            return <p key={index}>{ typeof customer.FullName != 'undefined' ? customer.FullName : 'No Name'}, { typeof customer.CompanyName != 'undefined' ? customer.CompanyName : 'No Company'}, { typeof customer.Email != 'undefined' ? customer.Email : 'No Email'}</p>
                                        })}
                                    </div>
                                </div>
                            ) : (
                            selectedRow.type == 'GetPayments' && (
                                <div>
                                    <div class="row">
                                        <div class="modal-section-title col-md-12" style={{marginBottom: "5px", marginTop: "15px"}}>Retrieved Payments</div>
                                        <div class="modal-section-content col-md-12" style={{fontSize: "13px"}}>Leases that contain a QuickBooks Customer Ref # will pull these payments.</div>
                                    </div>
                                    <div class="col-md-12 col-sm-12">
                                        { selectedRow.data != null && selectedRow.data.map(function(payment, index){
                                            return <p key={index}>Customer: {payment.CustomerRef.FullName}, Amount: {self.formatMoney(payment.TotalAmount)}</p>
                                        })}
                                        { selectedRow.data == null && (
                                            <p>No data to show.</p>
                                        )}
                                    </div>
                                </div>
                            )
                            )
                        )
                    )}
                </div>
                <div class="row">
                    <div class="col-md-12">
                    { selectedRow != null && selectedRow.data != null && selectedRow.type == 'GetCustomers' && (
                        <div class="col-md-4 col-sm-5 col-xs-7 pull-right" style={{padding: 0, marginTop: window.innerWidth < 768 ? 10 : 0}}>
                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.addTenants.bind(this)}>
                                Convert to Tenants
                            </button>
                        </div>
                    )}
                    { selectedRow != null && selectedRow.data != null && selectedRow.type == 'GetPayments' && (
                        <div class="col-md-5 col-sm-5 col-xs-7 pull-right" style={{padding: 0, marginTop: window.innerWidth < 768 ? 10 : 0}}>
                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.addPayments.bind(this)}>
                                Convert Payments to Leases
                            </button>
                        </div>
                    )}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </form>
            </Modal>
        );
        return (
            <div>
                {exploreDataModal}
                <div class="content">
                    <div class="col-md-12">
                    {logs != null && (
                        <BootstrapTable data={logs} version='4' striped search pagination hover options={options}>
                            <TableHeaderColumn width="50px" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='type' dataFormat={this.formatTypes}  dataSort={ true }>Action Type</TableHeaderColumn>
                            <TableHeaderColumn dataField='data' dataFormat={this.formatData} dataSort={ true }>Data</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.formatDate} dataSort={ true }>Queued Date</TableHeaderColumn>
                        </BootstrapTable>
                    )}
                    { logs == null && (
                        <p>No activity to show</p>
                    )}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/QuickBooks/QuickBooksDataExplorer.jsx